<script setup lang="ts">

import Translator from "@/utils/common/Translator.ts";
import {onBeforeMount, PropType, watch} from "vue";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import TreeViewPresenter from "@/utils/presenters/TreeViewPresenter.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import {QTree} from "quasar";

const props = defineProps({
  presenter: {type: Object as PropType<WidgetsPresenter>, required: true,},
  showTree: {type: Boolean, required: true}
});
const presenter: WidgetsPresenter = props.presenter;
const {compactMode, darkMode} = storeToRefs(useNamaFlagsStore());
const treeViewPresenter: TreeViewPresenter = new TreeViewPresenter(presenter, () => presenter.onTreeNodeSelection());
presenter.setTreeView(treeViewPresenter);
const treeRoots = treeViewPresenter.roots;

watch(() => treeViewPresenter.selectedNodeId.value, (nodeId) => {
  if (nodeId) {
    treeViewPresenter.expanded.value = treeViewPresenter.parentsOf(nodeId);
  }
});

onBeforeMount(async () => {
  await treeViewPresenter.start();
})
</script>
<template>
  <div class="tw-h-full"
       :class="[showTree? 'tw-w-fit tw-scale-x-100':'tw-w-0 tw-scale-x-0']">
    <q-scroll-area :dir="Translator.LTR" :dark="darkMode" class="tw-h-full tw-w-80 mobile:tw-w-48 tw-border tw-rounded tw-border-[--nama-ag-grid-border-color]">
      <q-slide-transition :dir="Translator.fetchDir()" class="tw-py-1 tw-h-full tw-transition-all tw-ease-in-out tw-duration-1000">
        <div class="tw-w-80 tw-px-2 mobile:tw-w-48" v-show="showTree">
          <q-tree
            ref="treeRef"
            v-model:selected="treeViewPresenter.selectedNodeId.value"
            v-model:expanded="treeViewPresenter.expanded.value"
            @update:selected="presenter.updateSelectedNodeId(treeViewPresenter.selectedNodeId.value)"
            :nodes="treeRoots"
            node-key="id"
            no-connectors
            :dark="darkMode"
            :dense="compactMode"
            class="!tw-h-full"
            selected-color="primary"
          />
        </div>
      </q-slide-transition>
    </q-scroll-area>
  </div>
</template>

<style scoped>

</style>
